<header [ngClass]="['variant-' + variant, noSticky ? 'no-sticky' : '']" >
  <div class="left-wrapper">
    <app-menu-toggle></app-menu-toggle>
    <button *ngIf="goBack" mat-icon-button (click)="goback()" aria-label="Volver">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="title-container" [class.single-line]="!id_code">
      <span class="title">{{ name_main }}</span>
      <span *ngIf="subtitle" class="subtitle">{{ subtitle }}</span>
      <span>{{ id_code }}</span>
    </div>
  </div>

  <div class="actions-header">
    <ng-content></ng-content>
    <ng-content></ng-content>
  </div>
</header>
